import { api } from '@/shared/api/client';
import type { Pagination } from '@/shared/types/api';
import type { GetContentCompletionResponse } from '../model/dto';

export const getContentCompletionRequest = async (params: Pagination) => {
  const { data } = await api.get<GetContentCompletionResponse>(
    '/users/me/course-content-completion-requests/',
    { params }
  );

  return data;
};
